var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import loadable from '@loadable/component';
import { Translate } from "../../../I18N";


const CodeEditorComponent = loadable(
  async () => {
    const { CodeEditorComponent: Component } = await import(
    /* webpackChunkName: "LazyLoadMonacoEditor" */"./CodeEditorComponent"
    );
    return Component;
  },
  {
    fallback: /*#__PURE__*/
    _jsx("div", { className: "w-full text-center" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Loading"), "\xA0..."
    )

  }
);

// eslint-disable-next-line react/jsx-props-no-spreading
const CodeEditor = (props) => /*#__PURE__*/React.createElement(CodeEditorComponent, props);

export { CodeEditor };